export const TEST_GOOGLE_PAY_MERCHANT_ID = 'BCR2DN4TRKZNX4DC';

export const GOOGLE_PAY_MERCHANT_NAME = 'LLP KASSA 24/7';

export const GOOGLE_PAY_MERCHANT_ID =
  process.env.REACT_APP_ENV_GOOGLE_PAY_MERCHANT_ID || TEST_GOOGLE_PAY_MERCHANT_ID;
